import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingBottom: 128
  }
}));

const ContentContainerMobile = ({ children }) => {
  const classes = useStyles({})
;
  return (
    <div className={classes.root}>
      <Typography variant="h4">EXPERIENCE</Typography>
      <Typography variant="h4">A TRANSFORMATION.</Typography>
      {children}
    </div>
  );
};

export default ContentContainerMobile;
